import { Button, FormControlLabel, RadioGroup } from "@material-ui/core";
import React from "react";
import { StyledRadioButton } from "./style-radio-button";
import "./radio-button-group.scss";
interface PropsFromParent {
  defaultValue: string;
  values: string[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export class RadioButtonGroup extends React.PureComponent<PropsFromParent> {

 private mapRadioButtons = (t: string) => (
    <FormControlLabel
      key={t}
      value={t}
      control={
        <StyledRadioButton 
          icon={<Button variant="contained" >{t} </Button>}
          checkedIcon={
            <Button disableRipple={true} variant="contained" color="primary" >
              {t}{" "}
            </Button>
          }
        />
      }
      label=""
    />
  )
  public render() {
    return (
      <RadioGroup
        className={"flexDirectionRow"}
        onChange={this.props.onChange}
        defaultValue={this.props.defaultValue}
        name="customized-radios"
      >
        {this.props.values.map(this.mapRadioButtons)}
      </RadioGroup>
    );
  }
}
